module.exports = __webpack_public_path__ + "img/2024091815180703102c.60eb8fcd.jpg";